function aboutGallerySliderInit() {
	$(".about-gallery-for").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: ".about-gallery-nav",
	});
	$(".about-gallery-nav").slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		fade: true,
		asNavFor: ".about-gallery-for",
		dots: true,
		centerMode: true,
		focusOnSelect: true,
		autoplay: true,
		autoplaySpeed: 5000,
	});
}
